"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-tags" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardTag = (0, vue_1.resolveComponent)("CardTag");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.tags.length <= 4)
            ? ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, (0, vue_1.renderList)(_ctx.tags, (cardTag, index) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardTag, {
                    key: index,
                    index: index,
                    type: cardTag
                }, null, 8, ["index", "type"]));
            }), 128))
            : ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardTag, {
                key: 0,
                index: 0,
                type: "asterisk"
            }))
    ]));
}
